export type AuthStatus =
    | 'unknown'
    | 'checking-auth'
    | 'loading-profile'
    | 'anonymous'
    | 'authenticated'
    | 'profile-error';

export const USER_GROUPS = {
    USER: 'user',
    ADMIN: 'admin',
    DRIVER: 'driver',
    WAREHOUSE_OPERATOR: 'warehouse_operator',
} as const;

export type UserRole = typeof USER_GROUPS[keyof typeof USER_GROUPS];
export type UserStatus = "ACTIVE" | "NOT_ACTIVE" | "DELETED";

export interface IUser {
    idUser: string;
    version: number;
    userStatus: IUserStatus;
    name: string;
    surname: string;
    phone: string;
    userCode: string;
    authSub: string;
    insertTime: string;
    groups: UserRole[];
}

interface IUserStatus {
    idUserStatus: UserStatus;
    description?: string;
}
